import { KeyboardArrowLeft } from '@styled-icons/material/KeyboardArrowLeft';
import { KeyboardArrowRight } from '@styled-icons/material/KeyboardArrowRight';
import styled from 'styled-components';
import { theme } from 'styled-tools';

const ArrowR = styled(KeyboardArrowRight)`
  color: ${theme('colors.orange')};
`;
const ArrowL = styled(KeyboardArrowLeft)`
  color: ${theme('colors.orange')};
`;

// TODO: refactor into separate styled components
const Nav = styled.nav`
  padding-top: 0;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    li {
      margin: 0;
      padding: 0;
      list-style: none;
      text-align: center;
      margin-right: 0.5rem;

      a {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        color: ${theme('colors.orange')};
        background-color: ${theme('colors.lightGray')};
        text-align: center;
        padding: 8px;
        min-width: 2rem;

        &:hover {
          background-color: ${theme('colors.mediumGray')};
        }
        &:active,
        &.active {
          color: ${theme('colors.white')};
          background-color: ${theme('colors.orange')};
        }
      }
    }
  }
`;

export { ArrowR, ArrowL, Nav };
